var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom-file-upload" },
    [
      _vm.fileList.length < _vm.maxCount
        ? _c(
            "van-uploader",
            {
              class: !_vm.uploaderBtnShow ? "uploaderBtnShowBox" : "",
              attrs: {
                "show-upload": false,
                "after-read": _vm.handleAfterRead,
                "max-count": _vm.maxCount - _vm.fileList.length,
                accept: _vm.compatibleAccept,
                "max-size": _vm.maxSize,
                "before-read": _vm.beforeRead,
                disabled: _vm.disabled,
                multiple: true,
                capture: _vm.environment ? "camera" : false,
              },
              on: { oversize: _vm.handleOversize },
              model: {
                value: _vm.filesList,
                callback: function ($$v) {
                  _vm.filesList = $$v
                },
                expression: "filesList",
              },
            },
            [
              _vm.uploaderBtnShow
                ? _c(
                    "van-button",
                    {
                      attrs: {
                        icon: "plus",
                        type: "primary",
                        disabled: _vm.disabled,
                      },
                    },
                    [_vm._v(" 上传文件 ")]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("fileComponent", {
        ref: "fileComponent",
        staticClass: "width-100",
        attrs: {
          fileListArr: _vm.fileList,
          uploaderBtnShow: _vm.uploaderBtnShow,
          disabled: _vm.disabled,
        },
        on: { removeFile: _vm.handleFileRemove },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }